/**
 * RouteBasedSEO Component
 * 
 * Automatically updates SEO meta tags based on current route
 * Uses getSEOByRoute from @/seo/appSEO to fetch route-specific SEO data
 * 
 * Integration: Place inside BrowserRouter in App.tsx
 */

import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import SEOManager from './SEOManager';
import { getSEOByRoute } from '@/seo/appSEO';
import { isPlatformHost } from '@/http';
import TenantSEO from './TenantSEO';

export const RouteBasedSEO: React.FC = () =>
  // An institute's own domain never gets our marketing head (TenantSEO).
  isPlatformHost() ? <PlatformSEO /> : <TenantSEO />;

const PlatformSEO: React.FC = () => {
  const location = useLocation();
  const seoData = getSEOByRoute(location.pathname);

  // Log route changes for debugging (remove in production)
  useEffect(() => {
    if (import.meta.env.DEV) {
      // console.log('[SEO] Route changed:', location.pathname, seoData);
    }
  }, [location.pathname, seoData]);

  return <SEOManager seoData={seoData} />;
};

export default RouteBasedSEO;
